<nz-space class="mobile-report-control">
  <app-stock-select #from [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    [showAddNewButton]="false" valueField="code" [showStockControlOnly]="showStockControlOnly">
  </app-stock-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-stock-select #to [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    [showAddNewButton]="false" valueField="code" [showStockControlOnly]="showStockControlOnly">
  </app-stock-select>
</nz-space>